(() => {
  const mobileMedia = window.matchMedia('(max-width: 989px)');
  const previewThemeId = '183188357404';
  let refreshFrame;

  const keepColourLinksInPreview = () => {
    document.querySelectorAll('.yv-pdp__swatch[href]').forEach((swatch) => {
      const url = new URL(swatch.href, window.location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      swatch.href = url.toString();
    });
  };

  const openMobileColour = (event) => {
    if (!mobileMedia.matches) return;

    const swatch = event.target.closest?.('.yv-pdp__swatch[href]');
    if (!swatch) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(swatch.href);
  };

  const getThumbs = (gallery) =>
    Array.from(gallery.querySelectorAll('[data-yv-thumb]')).filter(
      (thumb) => thumb.dataset.imageSrc
    );

  const getSignature = (thumbs) =>
    thumbs.map((thumb) => thumb.dataset.imageSrc).join('|');

  const setActive = (gallery, index) => {
    const thumbs = getThumbs(gallery);
    const dots = Array.from(
      gallery.querySelectorAll('.yv-pdp__mobile-dot')
    );

    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });

    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  };

  const bindThumbnailNavigation = (gallery) => {
    if (gallery.dataset.yvMobileSwipeBound === 'true') return;

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-yv-thumb]');
      const track = gallery.querySelector('.yv-pdp__mobile-track');

      if (!thumb || !track || !mobileMedia.matches) return;

      const index = getThumbs(gallery).indexOf(thumb);
      if (index < 0) return;

      track.scrollTo({
        left: track.clientWidth * index,
        behavior: 'smooth'
      });
    });

    gallery.dataset.yvMobileSwipeBound = 'true';
  };

  const enhanceGallery = (gallery) => {
    if (!mobileMedia.matches) return;

    const mainImage = gallery.querySelector('.yv-pdp__main-image');
    const thumbs = getThumbs(gallery);

    if (!mainImage || thumbs.length < 2) return;

    const signature = getSignature(thumbs);
    const currentTrack = gallery.querySelector('.yv-pdp__mobile-track');

    if (
      gallery.dataset.yvMobileSwipeSignature === signature &&
      currentTrack
    ) {
      return;
    }

    currentTrack?.remove();
    gallery.querySelector('.yv-pdp__mobile-dots')?.remove();

    const track = document.createElement('ul');
    const dots = document.createElement('div');

    track.className = 'yv-pdp__mobile-track';
    dots.className = 'yv-pdp__mobile-dots';
    dots.setAttribute('aria-hidden', 'true');

    thumbs.forEach((thumb, index) => {
      const slide = document.createElement('li');
      const image = document.createElement('img');
      const dot = document.createElement('span');

      slide.className = 'yv-pdp__mobile-slide';
      image.src = thumb.dataset.imageSrc;
      image.alt =
        thumb.dataset.imageAlt || thumb.querySelector('img')?.alt || '';
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.draggable = false;
      image.setAttribute('imgz-click-blocked', 'true');
      image.setAttribute('data-appify-imgz-ignore', 'true');
      dot.className = `yv-pdp__mobile-dot${
        index === 0 ? ' is-active' : ''
      }`;

      slide.append(image);
      track.append(slide);
      dots.append(dot);
    });

    let scrollFrame;
    track.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const index = Math.round(
            track.scrollLeft / Math.max(track.clientWidth, 1)
          );
          setActive(
            gallery,
            Math.min(Math.max(index, 0), track.children.length - 1)
          );
        });
      },
      { passive: true }
    );

    mainImage.append(track, dots);
    mainImage.classList.add('is-mobile-swipe');
    gallery.dataset.yvMobileSwipeSignature = signature;
    bindThumbnailNavigation(gallery);
    setActive(gallery, 0);
  };

  const enhanceAll = (root = document) => {
    if (root.matches?.('.yv-pdp__gallery')) enhanceGallery(root);
    root.querySelectorAll?.('.yv-pdp__gallery').forEach(enhanceGallery);
  };

  const scheduleRefresh = () => {
    window.cancelAnimationFrame(refreshFrame);
    refreshFrame = window.requestAnimationFrame(() => {
      keepColourLinksInPreview();
      enhanceAll();
    });
  };

  const init = () => {
    keepColourLinksInPreview();
    enhanceAll();

    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-image-src', 'data-image-alt']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  mobileMedia.addEventListener('change', (event) => {
    if (event.matches) enhanceAll();
  });

  document.addEventListener('shopify:section:load', (event) => {
    enhanceAll(event.target);
  });

  window.addEventListener('touchend', openMobileColour, {
    capture: true,
    passive: false
  });
  window.addEventListener('click', openMobileColour, true);
})();
